"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.backendOptions = void 0;
const i18next_localstorage_backend_1 = __importDefault(require("i18next-localstorage-backend")); // primary use cache
const i18next_http_backend_1 = __importDefault(require("i18next-http-backend")); // fallback http load
// eslint-disable-next-line import/prefer-default-export
const backendOptions = (bucketBase, productName, store, expirationTime, // expiration : 7 days
cache) => ({
    backends: [
        // Cache Translations : https://github.com/i18next/i18next-localstorage-backend
        i18next_localstorage_backend_1.default,
        // Load through HTTP
        i18next_http_backend_1.default,
        i18next_http_backend_1.default,
    ],
    backendOptions: [
        // LocalStorageBackend options
        {
            prefix: 'i18next_res_',
            expirationTime,
            defaultVersion: 'v1.0',
            versions: {},
            store: typeof window !== 'undefined' ? window[store] : null, // can be either window.localStorage or window.sessionStorage. Default: window.localStorage
        },
        // HttpApi Options for product translations
        {
            allowMultiLoading: false,
            // Load product translations
            loadPath: `${bucketBase}/${encodeURI(productName)}/i18n/{{lng}}/{{ns}}.json`,
            requestOptions: { cache },
        },
        // HttpApi Options for backend translations
        {
            allowMultiLoading: false,
            // Load product translations
            loadPath: `${bucketBase}/i18n/{{lng}}/{{ns}}.json`,
            requestOptions: { cache },
        },
    ],
});
exports.backendOptions = backendOptions;
